module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    class: _vm.classes
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "info-total"
  }, [_vm._v(_vm._s(_vm.total))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ac9a686","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoBox/InfoBox.vue
// module id = 974
// module chunks = 3